<template>
    <FORM
        v-slot="{ errors }"
        :validation-schema="schema"
        :initial-values="formValues"
        @submit="onSubmit"
    >
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
                <h1 class="font-bold text-lg text-primary mb-6">1.Información Personal</h1>
                <Field v-slot="{ field, errorMessage }" name="name">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Nombre*"
                            :class="{ 'p-invalid': errorMessage }"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="last_name">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Apellido paterno*"
                            :class="{ 'p-invalid': errorMessage }"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="mothers_last_name">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Apellido materno*"
                            :class="{ 'p-invalid': errorMessage }"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="email">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            :disabled="true"
                            placeholder="Email*"
                            :class="{ 'p-invalid': errorMessage }"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="model">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Modelo*"
                            :class="{ 'p-invalid': errorMessage }"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="year">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="year-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Año*"
                            maxlength="4"
                            :class="{ 'p-invalid': errorMessage }"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.target.value.length <= 4"
                        />

                        <small id="year-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="km_id">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="couponSore.couponMileage"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="name"
                            option-value="km_id"
                            placeholder="Kilometraje*"
                            @update:model-value="handleChange"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="state_id">
                    <div class="field mb-5">
                        <!-- eslint-disable -->
                        <Dropdown
                            :model-value="value"
                            :options="catalogStore.statesArray"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="description"
                            option-value="state_id"
                            placeholder="Estado*"
                            @update:model-value="handleChange"
                            @change="(e: any) => getDealears(e)"
                        />
                        <!-- eslint-disable -->
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="dealer_id">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="catalogStore.dealerArray"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="name"
                            option-value="dealer_id"
                            placeholder="Concesionaria*"
                            @update:model-value="handleChange"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
                <h1 class="font-bold text-lg text-primary mb-6">2. Datos de contacto</h1>
                <Field v-slot="{ field, errorMessage }" name="address">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            placeholder="Dirección*"
                            :class="{ 'p-invalid': errorMessage }"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="stateContact">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="catalogStore.statesArray"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="description"
                            option-value="state_id"
                            placeholder="Estado*"
                            @update:model-value="handleChange"
                            @change="(e: any) => getCities(e)"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="city_id">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="catalogStore.citiesArray"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="description"
                            option-value="city_id"
                            placeholder="Ciudad*"
                            @update:model-value="handleChange"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="zipcode">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            maxlength="5"
                            placeholder="Código Postal (5 Dígitos)*"
                            :class="{ 'p-invalid': errorMessage }"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.target.value.length <= 5"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="phone1">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            maxlength="10"
                            placeholder="Teléfono (10 dígitos)*"
                            :class="{ 'p-invalid': errorMessage }"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.target.value.length <= 10"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="phone_type1">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="telOptions"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="name"
                            option-value="value"
                            placeholder="Teléfono*"
                            @update:model-value="handleChange"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ field, errorMessage }" name="phone2">
                    <div class="field mb-5">
                        <InputText
                            v-bind="field"
                            aria-describedby="email-help"
                            class="w-12 md:w-12 lg:w-12 xl:w-8"
                            maxlength="10"
                            placeholder="Teléfono (10 dígitos)"
                            :class="{ 'p-invalid': errorMessage }"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.target.value.length <= 10"
                        />
                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
                <Field v-slot="{ value, errorMessage, handleChange }" name="phone_type2">
                    <div class="field mb-5">
                        <Dropdown
                            :model-value="value"
                            :options="telOptions"
                            class="p-dropdown w-12 md:w-12 lg:w-12 xl:w-8"
                            option-label="name"
                            option-value="value"
                            placeholder="Teléfono"
                            @update:model-value="handleChange"
                        />

                        <small id="email-help" class="p-error block">{{ errorMessage }}</small>
                    </div>
                </Field>
            </div>

            <div class="col-12 mt-6">
                <div>
                    <Field
                        id="authorize_privacy"
                        name="authorize_privacy"
                        type="checkbox"
                        :value="true"
                        class="p-checkbox checkbox-color"
                        :class="{ 'is-invalid': errors.authorize_privacy }"
                    />
                    <label v-if="brand === 'vw'" for="authorize_privacy" class="ml-2"
                        >He leído y acepto el
                        <a target="_blank" href="https://www.vw.com.mx/es/legal/aviso-de-privacidad.html"
                            >Aviso de Privacidad</a
                        >.</label
                    >
                    <label v-if="brand === 'audi'" for="authorize_privacy" class="ml-2"
                        >He leído y acepto el
                        <a target="_blank" href="https://www.audi.com.mx/mx/web/es/tools/navigation/layer/legal.html"
                            >Aviso de Privacidad</a
                        >.</label
                    >
                    <label v-if="brand === 'seat'" for="authorize_privacy" class="ml-2"
                        >He leído y acepto el
                        <a target="_blank" href="https://www.seat.mx/compania/aviso-de-privacidad"
                            >Aviso de Privacidad</a
                        >.</label
                    >
                    <label v-if="brand === 'porsche'" for="authorize_privacy" class="ml-2"
                        >He leído y acepto el
                        <a target="_blank" href="https://www.porsche.com/mexico/privacy-policy/"
                            >Aviso de Privacidad</a
                        >.</label
                    >
                    <div class="p-error block">{{ errors.authorize_privacy }}</div>
                </div>

                <div class="mt-3">
                    <Field
                        id="authorize_contact"
                        name="authorize_contact"
                        type="checkbox"
                        :value="true"
                        class="p-checkbox checkbox-color"
                        :class="{ 'is-invalid': errors.authorize_contact }"
                    />
                    <label v-if="brand === 'vw'" for="authorize_contact" class="ml-2"
                        >Acepto que mis datos personales aquí proporcionados sean transferidos al
                        Concesionario marca Volkswagen que elegido, a efecto de que den seguimiento a mi
                        solicitud.</label
                    >
                    <label v-if="brand === 'audi'" for="authorize_contact" class="ml-2"
                        >Acepto que mis datos personales aquí proporcionados sean transferidos al
                        Concesionario marca Audi que elegido, a efecto de que den seguimiento a mi
                        solicitud.</label
                    >
                    <label v-if="brand === 'seat'" for="authorize_contact" class="ml-2"
                        >Acepto que mis datos personales aquí proporcionados sean transferidos al
                        Concesionario marca Seat que elegido, a efecto de que den seguimiento a mi
                        solicitud.</label
                    >
                    <label v-if="brand === 'porsche'" for="authorize_contact" class="ml-2"
                        >Acepto que mis datos personales aquí proporcionados sean transferidos al
                        Concesionario marca Porsche que elegido, a efecto de que den seguimiento a mi
                        solicitud.</label
                    >
                    <div class="p-error block">{{ errors.authorize_contact }}</div>
                </div>
            </div>
        </div>
        <div class="footer">
            <PrimeButton
                type="submit"
                :disabled="disabledButton"
                :icon="disabledButton === true ? 'pi pi-spin pi-spinner' : ''"
                class="rounded w-10 md:w-6 lg:w-8 xl:w-3 mt-6 block mt-6 block"
                label="Generar Cupon"
            />
        </div>
    </FORM>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Field, Form as FORM } from "vee-validate";
import { useCatalogStore } from "../stores/catalogos/catalogosStore";
import { useCouponStore } from "../stores/cupones/couponStore";
import { useRouter } from "vue-router";
import * as yup from "yup";
import { notify } from "@kyvg/vue3-notification";

export default defineComponent({
    name: "UserForm",
    components: {
        Field,
        FORM,
    },
    setup() {
        const catalogStore = useCatalogStore();
        const couponSore = useCouponStore();
        const requeriedFieldMessage = "El campo es requerido";
        const router = useRouter();
        const disabledButton = ref(false);
        const brand = import.meta.env.VITE_BRAND;
        /**
         * Variable para inicializar el valor de algunos campos del formulario
         */
        const formValues = {
            phone2: "",
            phone_type2: "",
            email: couponSore.emailUser,
            stateContact: 0,
            state_id: 0,
        };
        /**
         * Funcion para iniciar el componente en donde se consultan los catalogos necesarios para
         * los dropdwn del formulario
         * @return {null} Sin respuesta
         */
        onMounted(async () => {
            if (couponSore.emailUser === "") {
                notify({
                    title: "No existe correo",
                    type: "warn",
                    text: "Será redirigido al inicio para colocar uno.",
                });
                setTimeout(async function () {
                    router.push(`/home/${localStorage.getItem("campaing_id")}`);
                }, 2000);
            }
            await catalogStore.getMileage();
            await catalogStore.getStates();
        });
        /**
         * Función para enviar la información del formulario
         * @param {any} values - Es el objeto que contiene las acciones del formualrio y con él podemos resetear el formulario.
         * @return {void} Sin respuesta
         */
        async function onSubmit(values: any) {
            disabledButton.value = true;
            const response = await couponSore.createCoupon(couponSore.campaingId, values);
            const status = couponStatusAndCode(response);
            disabledButton.value = false;
            router.push({ path: "/cupon", query: { status: status } });
        }
        /**
         * Función para validar cual es el status del cupón que se acaba de generar, los valores
         * que se setean son valores estáticos que le dimos en el front y se recuperan
         * en la vista de coupon
         */
        function couponStatusAndCode(data: any): string {
            couponSore.setCodeCoupon(data.code);
            couponSore.setCampaingName(data.campaign.name);
            let flag = "";
            if (data.redeemed) {
                flag = "3";
            } else if (!data.closed && data.status) {
                flag = "1";
            }
            return flag;
        }
        /**
         * Variable para los tipos de telefono que puede dejar el cliente
         * estos son estáticos
         */
        const telOptions = ["Casa", "Oficina", "Móvil", "Teléfono"].map((tel: string) => ({
            name: tel,
            value: tel.toLowerCase(),
        }));

        /**
         * variable que contiene las validaciones del formulario para decidir que campos son obligatorios y de que tipo
         * @return {null} Sin respuesta
         */
        const phoneRegExp =
            /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        const schema = yup.object().shape({
            name: yup.string().required(requeriedFieldMessage).label("Nombre"),
            last_name: yup.string().required(requeriedFieldMessage).label("Apellido Paterno"),
            mothers_last_name: yup.string().optional().label("Apellido Materno"),
            email: yup
                .string()
                .required(requeriedFieldMessage)
                .email("El correo debe de ser válido")
                .label("Correo electronico"),
            model: yup.string().required(requeriedFieldMessage).label("Modelo"),
            year: yup.string().required(requeriedFieldMessage).label("Modelo/Año"),
            km_id: yup.string().required(requeriedFieldMessage).label("Kilometraje"),
            state_id: yup.string().required(requeriedFieldMessage).label("Estado"),
            dealer_id: yup.string().required(requeriedFieldMessage).label("Concesionaria"),
            address: yup.string().required(requeriedFieldMessage).label("Dirección"),
            stateContact: yup.string().required(requeriedFieldMessage).label("Estado contacto"),
            city_id: yup.string().required(requeriedFieldMessage).label("Ciudad"),
            zipcode: yup.number().required(requeriedFieldMessage).label("Código postal"),
            phone1: yup
                .string()
                .matches(phoneRegExp, "Caracteres no validos")
                .required(requeriedFieldMessage),
            phone_type1: yup.string().required(requeriedFieldMessage).label("Teléfono"),
            phone2: yup.string().optional().label("Segundo teléfono"),
            phone_type2: yup.string().optional().label("Segundo Select teléfono"),
            authorize_privacy: yup.bool().required("Es necesario aceptar"),
            authorize_contact: yup.bool().required("Es necesario aceptar"),
        });
        /**
         * Función para obtener las concesionarias por estado
         * @param {any} val - es el evento que se dispara cuando se cambia el valor
         * del dropdown, allí es donde se obtiene el ID del estado para consultar sus
         * concesionarias disponibles.
         * @return {null} Sin respuesta
         */
        function getDealears(val: any) {
            catalogStore.filterConsecionaria(val.value);
        }
        /**
         * Función para obtener las las ciudades por estado
         * @param {any} val - es el evento que se dispara cuando se cambia el valor
         * del dropdown, allí es donde se obtiene el ID del estado para consultar sus
         * ciudades disponibles.
         * @return {null} Sin respuesta
         */
        function getCities(val: any) {
            catalogStore.filterCities(val.value);
        }

        return {
            onSubmit,
            getCities,
            getDealears,
            brand,
            schema,
            telOptions,
            catalogStore,
            couponSore,
            disabledButton,
            formValues,
        };
    },
});
</script>

<style></style>
